import type { DynamicComboboxOption } from '@shared/components/ui/DynamicCombobox';
import { useCallback } from 'react';
import { useMinimumFeesAdapter } from './useMinimumFees';

export const useMinimumFeeFilterOptions = () => {
  const adapter = useMinimumFeesAdapter();

  const searchTeams = useCallback(
    async (query: string): Promise<DynamicComboboxOption[]> => {
      const result = await adapter.searchTeams({ search: query, page: 1, limit: 100 });
      return result.options;
    },
    [adapter],
  );

  const resolveTeamOption = useCallback(
    async (value: string): Promise<DynamicComboboxOption | null> => adapter.getTeamOption(value),
    [adapter],
  );

  const searchInvoices = useCallback(
    async (query: string): Promise<DynamicComboboxOption[]> => {
      const result = await adapter.searchInvoices({ search: query, page: 1, limit: 100 });
      return result.options;
    },
    [adapter],
  );

  const resolveInvoiceOption = useCallback(
    async (value: string): Promise<DynamicComboboxOption | null> => adapter.getInvoiceOption(value),
    [adapter],
  );

  return {
    searchTeams,
    resolveTeamOption,
    searchInvoices,
    resolveInvoiceOption,
  };
};
